export default "__VITE_ASSET__Mx3K0xrE__"